import usePagination from '@/hooks/usePagination';
import { Maybe, SortType, UsersFilters } from '@/types/schema';

import { UsersFilterQuery, useUsersFilterQuery } from '../../graphql/queries/generated/usersFilter';

export type UserFilterItemType = NonNullable<UsersFilterQuery['users']['edges']>[0]['node'];

function useUsersFilter({
  sort,
  filters,
  pageSize,
  pause,
}: {
  sort?: Maybe<SortType[]>;
  filters: UsersFilters;
  pageSize?: number;
  pause?: boolean;
}) {
  const { data, error, isLoading, fetchMore, isFetchingMore, totalCount } = usePagination(
    useUsersFilterQuery,
    {
      filters,
      sort,
    },
    {
      edgeKey: 'users',
      pause,
      pageSize,
    },
  );

  return {
    users: data,
    isLoading: isLoading || isFetchingMore,
    error,
    fetchMore,
    totalCount,
  };
}

export default useUsersFilter;
